var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCoffee = function SvgCoffee(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "coffee_svg__a",
    width: 24,
    height: 25,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 .094h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#coffee_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.836 21.212q-1.348 0-2.255-.933t-.907-2.256V10.74q0-.725.518-1.244a1.73 1.73 0 0 1 1.27-.517h12.156a1.7 1.7 0 0 1 1.244.517q.52.518.52 1.244v1.867q0 .75-.52 1.27-.519.518-1.244.518h-1.555v3.628q0 1.323-.907 2.256-.906.933-2.255.933zm0-1.14H13.9q.83 0 1.425-.61a2 2 0 0 0 .596-1.439v-7.905h-9.46a.66.66 0 0 0-.466.17.59.59 0 0 0-.182.452v7.283q0 .83.596 1.44.597.608 1.426.608m9.227-6.817h1.555a.6.6 0 0 0 .44-.182.63.63 0 0 0 .182-.466V10.74q0-.284-.181-.453a.62.62 0 0 0-.44-.169h-1.556zM6.6 6.367c-.548.501.212 1.341.766.843a1.71 1.71 0 0 0 .202-2.355c-.247-.364-.24-.634.024-.874.544-.502-.214-1.338-.766-.843a1.71 1.71 0 0 0-.201 2.355c.247.364.24.634-.024.874M10.356 6.355c-.564.486.173 1.348.74.865.706-.6.81-1.656.226-2.378-.246-.364-.239-.634.025-.874.54-.502-.213-1.332-.765-.842a1.71 1.71 0 0 0-.202 2.354c.247.365.24.635-.025.875M14.11 6.355c-.563.486.174 1.348.742.865.705-.6.809-1.656.226-2.378-.247-.364-.24-.634.024-.874.54-.502-.213-1.332-.765-.842a1.71 1.71 0 0 0-.202 2.354c.247.365.24.635-.024.875"
  }))));
};
export default SvgCoffee;